export enum DateFormat {
    DayMonthYear = 1,
    MonthDayYear = 2,
    YearMonthDay = 3
}